/**
 * @fileoverview Viewport flags for the registration corporate identity form.
 * @module components/AppointmentRegistrationSections/CorporateIdentity/useRegistrationViewport
 */
const MEDIUM_MOBILE_MIN = 481;
const MEDIUM_MOBILE_MAX = 767;
const SMALL_MOBILE_MIN = 320;
const SMALL_MOBILE_MAX = 480;

/**
 * @returns {{ isMobile: boolean }}
 */
export const getRegistrationViewport = () => {
  const width = window.innerWidth;
  const isMediumMobile = width >= MEDIUM_MOBILE_MIN && width <= MEDIUM_MOBILE_MAX;
  const isSmallMobile = width >= SMALL_MOBILE_MIN && width <= SMALL_MOBILE_MAX;
  return { isMobile: isMediumMobile || isSmallMobile };
};
